import { useQuery } from '@tanstack/react-query'
import { fetchBlogs, fetchBlog } from '@/blogs/blogApi'
import { API_ROUTES } from '@/common/constants'

export function useFetchBlogs(enabled = true) {
    return useQuery({
        queryKey: [API_ROUTES.blogs],
        queryFn: async () => {
            const res = await fetchBlogs()
            return res
        },
        enabled,
    })
}

export function useFetchBlog(slug: string | null, enabled = true) {
    return useQuery({
        queryKey: [API_ROUTES.blog, slug],
        queryFn: async () => fetchBlog(slug!),
        enabled: !!slug && enabled,
    })
}

export default {
    useFetchBlogs,
    useFetchBlog,
}
